import { inject, InjectionToken } from '@angular/core';

import { asserts } from '../../../core/utils/assertion';
import { AuthService } from '../auth.service';
import { AbstractRefreshTokenAdaptor } from './abstract-refresh-token.adaptor';
import { RefreshTokenError, RefreshTokenErrorMessage } from './refresh-token-error';

export interface AuthSessionCheckFn {
  (checkExpiry: () => void): void;
}

export const AuthSessionCheckFn = new InjectionToken<AuthSessionCheckFn>('AuthSessionCheckFn');

export function AuthSessionGuardInit() {
  const auth = inject(AuthService);
  const refreshTokenAdaptor = inject(AbstractRefreshTokenAdaptor, { optional: true });
  const authSessionCheckFn = inject(AuthSessionCheckFn, { optional: true });
  authSessionCheckFn?.(checkExpiry);

  function checkExpiry() {
    if (auth.isTokenTypeRefreshToken() && auth.tokenInstance.isRefreshTokenExpire()) {
      asserts(refreshTokenAdaptor, 'AbstractRefreshTokenAdaptor not provided');

      refreshTokenAdaptor.onRefreshTokenFail(
        { ...auth.tokenInstance },
        new RefreshTokenError(RefreshTokenErrorMessage.SESSION_EXPIRED),
      );
    }
  }
}
